import './Pagination.css';

function getPageNumbers(currentPage, totalPages) {
    // 0-based currentPage, totalPages is count
    if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, i) => i);
    }

    const pages = new Set([0, totalPages - 1]);

    // Pages around current
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i >= 0 && i < totalPages) {
            pages.add(i);
        }
    }

    const sorted = [...pages].sort((a, b) => a - b);

    // Insert ellipsis markers
    const result = [];
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
            result.push('...');
        }
        result.push(sorted[i]);
    }

    return result;
}

function Pagination({ currentPage, totalPages, totalElements, onPageChange, itemLabel }) {
    if (totalPages <= 1) return null;

    const pageNumbers = getPageNumbers(currentPage, totalPages);

    return (
        <div className="pagination-container">
            <button
                className="pagination-button"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 0}
            >
                &lsaquo; Předchozí
            </button>

            <div className="pagination-pages">
                {pageNumbers.map((page, index) =>
                    page === '...' ? (
                        <span key={`ellipsis-${index}`} className="page-ellipsis">&hellip;</span>
                    ) : (
                        <button
                            key={page}
                            className={`page-number${page === currentPage ? ' active' : ''}`}
                            onClick={() => onPageChange(page)}
                        >
                            {page + 1}
                        </button>
                    )
                )}
            </div>

            <button
                className="pagination-button"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages - 1}
            >
                Dal&scaron;&iacute; &rsaquo;
            </button>

            {totalElements != null && itemLabel && (
                <div className="pagination-info">
                    <span className="total-count">({totalElements} {itemLabel} celkem)</span>
                </div>
            )}
        </div>
    );
}

export default Pagination;
